import { AccountBalance } from "@mui/icons-material";
import React from "react";

const FinanseIcon = () => {
    return <AccountBalance sx={{ width: "1.063rem", height: "1.125rem" }} />;
};

export default FinanseIcon;
